import { render, staticRenderFns } from "./LabelProjectsList.vue?vue&type=template&id=4e2eb85c"
import script from "./LabelProjectsList.vue?vue&type=script&lang=js"
export * from "./LabelProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports